/** Resolves a caller-supplied {action} template; plain names pass through unchanged. */
export function getDatadogActionName(
  template: string | undefined,
  action: string,
): string | undefined {
  return template?.replace("{action}", action);
}
